import {createContext} from 'react';
export const CaptchaContext = createContext();
